import React from "react";
import { Box, Flex, Text, Icon, Divider, Stack } from "@chakra-ui/react";
import { Shield, Hash, ArrowDownWideNarrow, ArrowUpWideNarrow, Percent } from "lucide-react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";

const ViewProtectionTierDrawer = ({ isOpen, onClose, tier }) => {
  if (!tier) return null;

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={
        <Text fontSize="2xl" fontWeight="bold">
          Protection Tier
        </Text>
      }
      bodyContent={
        <Flex direction="column" p={8} width="100%">
          {/* Header */}
          <Box>
            <Text fontSize="2xl" fontWeight="bold">
              Tier Range: {tier.min_value} - {tier.max_value}
            </Text>
            <Text fontSize="sm" color="gray.500" mt={1}>
              Rate: {tier.rate}
            </Text>
          </Box>

          <Divider my={6} />

          <Flex direction="column" p={4}>
            <Box mb={6}>
              <Stack spacing={4}>
                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={ArrowDownWideNarrow} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Min Value: {tier.min_value}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={ArrowUpWideNarrow} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Max Value: {tier.max_value}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Percent} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Rate: {tier.rate}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Shield} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Created At: {tier.created_at ? new Date(tier.created_at).toLocaleString() : "N/A"}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Shield} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Updated At: {tier.updated_at ? new Date(tier.updated_at).toLocaleString() : "N/A"}
                  </Text>
                </Flex>
              </Stack>
            </Box>
          </Flex>
        </Flex>
      }
    />
  );
};

export default ViewProtectionTierDrawer;